import { ProgramBasic } from './ProgramBasic'

let programBasicStorage = localStorage.getItem('programBasic') as unknown as undefined | ProgramBasic

if (programBasicStorage) {
    try {
        programBasicStorage = JSON.parse(programBasicStorage as unknown as string)
    } catch {
        programBasicStorage = undefined
        localStorage.removeItem('programBasic')
    }
}

async function getProgramBasic() {
    if (programBasicStorage) {
        if (programBasicStorage.startTime * 1000 < Date.now() && Date.now() < programBasicStorage.endTime * 1000) {
            return programBasicStorage
        }

        programBasicStorage = undefined
        localStorage.removeItem('programBasic')
    }

    programBasicStorage = await fetch('https://test-api.kaiba315.com.cn/n/program/v2/obj/getCurrentBasic?siteId=9', {
        method: 'POST',
    })
        .then((res) => res.json())
        .then((res) => {
            return res.data
        })

    if (!programBasicStorage) {
        return Promise.reject('获取档期节目失败')
    }

    localStorage.setItem('programBasic', JSON.stringify(programBasicStorage))

    return programBasicStorage as ProgramBasic
}

export async function getCurrentBasic() {
    const { programId, programName, scheduleId, scheduleName, emceeIds, emceeNames } = await getProgramBasic()

    return { programId, programName, scheduleId, scheduleName, emceeIds, emceeNames }
}
